export default __webpack_public_path__ + "static/media/download-icon.095487af.svg";